export const STRIPE_PUBLIC_KEY = 'pk_live_a5XJAcVaIqMs8ggZMtluZs8z00r2H4kYVG';
export const STRIPE_API_VERSION = '2022-11-15';
